var _ellipse, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLoanDueIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 62,
    height: 61,
    viewBox: "0 0 62 61",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 30.761,
    cy: 30.0734,
    rx: 30.4367,
    ry: 30.0339,
    fill: "#920583",
    fillOpacity: 0.2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.8887 25.1111C24.8887 24.787 25.0174 24.4761 25.2467 24.2469C25.4759 24.0177 25.7867 23.8889 26.1109 23.8889H35.8887C36.2128 23.8889 36.5237 24.0177 36.7529 24.2469C36.9821 24.4761 37.1109 24.787 37.1109 25.1111C37.1109 25.4353 36.9821 25.7462 36.7529 25.9754C36.5237 26.2046 36.2128 26.3334 35.8887 26.3334H26.1109C25.7867 26.3334 25.4759 26.2046 25.2467 25.9754C25.0174 25.7462 24.8887 25.4353 24.8887 25.1111V25.1111ZM30.9998 34.8889C31.6481 34.8889 32.2698 34.6314 32.7283 34.173C33.1867 33.7145 33.4442 33.0928 33.4442 32.4445C33.4442 31.7962 33.1867 31.1744 32.7283 30.716C32.2698 30.2576 31.6481 30 30.9998 30C30.3515 30 29.7297 30.2576 29.2713 30.716C28.8129 31.1744 28.5553 31.7962 28.5553 32.4445C28.5553 33.0928 28.8129 33.7145 29.2713 34.173C29.7297 34.6314 30.3515 34.8889 30.9998 34.8889Z",
    fill: "#920583"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.6667 19C22.6942 19 21.7616 19.3863 21.0739 20.0739C20.3863 20.7616 20 21.6942 20 22.6667V37.3333C20 38.3058 20.3863 39.2384 21.0739 39.9261C21.7616 40.6137 22.6942 41 23.6667 41H38.3333C39.3058 41 40.2384 40.6137 40.9261 39.9261C41.6137 39.2384 42 38.3058 42 37.3333V22.6667C42 21.6942 41.6137 20.7616 40.9261 20.0739C40.2384 19.3863 39.3058 19 38.3333 19H23.6667ZM38.3333 21.4444H23.6667C23.3425 21.4444 23.0316 21.5732 22.8024 21.8024C22.5732 22.0316 22.4444 22.3425 22.4444 22.6667V37.3333C22.4444 37.6575 22.5732 37.9684 22.8024 38.1976C23.0316 38.4268 23.3425 38.5556 23.6667 38.5556H38.3333C38.6575 38.5556 38.9684 38.4268 39.1976 38.1976C39.4268 37.9684 39.5556 37.6575 39.5556 37.3333V22.6667C39.5556 22.3425 39.4268 22.0316 39.1976 21.8024C38.9684 21.5732 38.6575 21.4444 38.3333 21.4444Z",
    fill: "#920583"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoanDueIcon);
export default __webpack_public_path__ + "static/media/LoanDueIcon.4d73c6ebab2540e6dfec2393ecaa0ee3.svg";
export { ForwardRef as ReactComponent };